module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/roma.6a36af50176c65310922cf0bf31cdf7e.jpg";